module.exports = __webpack_public_path__ + "static/media/CodeApplication.507690f8.jpg";